import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { DatabusService } from './services/databus.service';
import { DecodeTicketService } from './services/decode-ticket.service';
import { KeyboardServiceService } from './keyboard-service/keyboard-service.service';
import { ValidationService } from './services/validation.service';
import { StatesService } from './services/states.service';

import { KeyboardComponent } from './keyboard/keyboard.component';
import { KeyComponent } from './key/key.component';
import { GsKeyboardDirective } from './keyboard-directive/gskeyboard.directive';
import { SpinnerComponent } from './spinner/spinner.component';
import { ArrowsComponent } from './arrows/arrows.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule
  ],
  declarations: [ KeyboardComponent, KeyComponent, GsKeyboardDirective, SpinnerComponent, ArrowsComponent ],
  providers: [ StatesService, ValidationService, DatabusService, DecodeTicketService, KeyboardServiceService, KeyboardComponent ],
  exports: [
    KeyComponent, 
    KeyboardComponent,
    GsKeyboardDirective,
    SpinnerComponent,
    ArrowsComponent
  ]
})
export class SharedModule { }


// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/shared/shared.module.ts